const DataActionType = {
  DATA_LOAD_START: 'data_load_start',
  DATA_LOAD_SUCCESS: 'data_load_success',
  DATA_LOAD_FAILURE: 'data_load_failure',
  DATA_RESET: 'data_reset',
} as const;

export default DataActionType;
